import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { apiCall } from "../../utils/apiService";
import "./ApiTestPage.css";

const MessageHeaderLayer = ({ getHeaderData }) => {
  const [instances, setInstances] = useState([]);
  const [apiKey, setApiKey] = useState("");
  const [selectedId, setSelectedId] = useState("");

  const fetchInstances = async () => {
    try {
      const response = await apiCall({
        url: `sessions/get-users-instances`,
        method: "GET",
      });
      setInstances(response.data || []);
    } catch (error) {
      console.error("Error fetching instances:", error);
    }
  };

  useEffect(() => {
    const key = localStorage.getItem("apiKey") || "";
    setApiKey(key);
    fetchInstances();
    getHeaderData?.("", key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pushHeader = (id, key) => {
    getHeaderData?.(id, key);
  };

  return (
    <div className="api-test-header">
      <div className="api-test-field">
        <label htmlFor="api-test-instance">
          <Icon icon="logos:whatsapp-icon" width={14} className="me-1" />
          Instance
        </label>
        <select
          id="api-test-instance"
          className="form-select"
          value={selectedId}
          onChange={(e) => {
            const id = e.target.value;
            setSelectedId(id);
            pushHeader(id, apiKey);
          }}
        >
          <option value="" disabled>
            Select Instance
          </option>
          {instances.map((instance) => (
            <option key={instance.client_id} value={instance.client_id}>
              {instance.name || instance.client_id}
            </option>
          ))}
        </select>
      </div>

      <div className="api-test-field">
        <label htmlFor="api-test-token">
          <Icon icon="mdi:key-outline" width={14} className="me-1" />
          API Token
        </label>
        <input
          id="api-test-token"
          type="text"
          className="form-control"
          placeholder="Your API token"
          value={apiKey}
          onChange={(e) => {
            const key = e.target.value;
            setApiKey(key);
            pushHeader(selectedId, key);
          }}
        />
      </div>
    </div>
  );
};

export default MessageHeaderLayer;
